import Vue from "vue";
import PropertySyncMixin from "./PropertySyncMixin";
import { pickBy } from "lodash";

let defaultFilters = {};

const FilterableMixin = Vue.util.mergeOptions(PropertySyncMixin, {
    computed: {
        shouldRenderPagination() {
            return _.get(this.meta, "last_page", 1) > 1;
        },
    },
    data() {
        return {
            filters: {},
            meta: {},
        };
    },
    methods: {
        handleFilter(page = 1, replace = false) {
            const query = pickBy({
                ...this.filters,
                page,
            });
            const payload = {
                path: this.$route.path,
                query,
            };
            if (replace) return this.$router.replace(payload);
            return this.$router.push(payload);
        },
        parseDateToQuery(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        preselectFilters(filters = {}) {
            Object.keys(filters).forEach((key) => {
                this.filters[key] =
                    _.get(this.$route.query, key) || filters[key];
            });
            defaultFilters = { ...filters };
        },
        resetFilter() {
            this.filters = { ...defaultFilters };
            this.handleFilter();
        },
        syncFilterToProperty(filter, property, url, propertyAttribute = "id") {
            return this.syncToPropWithAjax(
                filter,
                property,
                url,
                propertyAttribute
            );
        },
        syncPropertyToFilter(property, filter, propertyAttribute = "id") {
            this.syncToProp(
                _.get(property, propertyAttribute, null),
                `filters.${filter}`
            );
        },
    },
});

export default FilterableMixin;
